module.exports = __webpack_public_path__ + "static/media/background_3.16033b7a.jpg";